module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-drawer', {
    staticClass: "app-drawer",
    attrs: {
      "open": _vm.open,
      "docked": _vm.docked,
      "overlay": _vm.docked,
      "zDepth": 1
    },
    on: {
      "hide": _vm.handleHide,
      "close": _vm.handleClose
    }
  }, [_c('mu-appbar', {
    staticClass: "exmaples-nav-appbar",
    attrs: {
      "zDepth": 0
    }
  }, [_c('a', {
    staticClass: "exmaples-appbar-title"
  }, [_vm._v("欢迎 " + _vm._s(_vm.user.managerName))])]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('div', {
    staticClass: "exmaple-drawer-content"
  }, [_c('mu-list', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "value": _vm.menuVal
    },
    on: {
      "change": _vm.handleMenuChange
    }
  }, _vm._l((_vm.menuTree), function(item) {
    return _c('mu-list-item', {
      attrs: {
        "value": item.v ? '#/' + item.v : undefined,
        "toggleNested": !item.l,
        "open": item.l,
        "title": item.t
      }
    }, _vm._l((item.s), function(i) {
      return _c('mu-list-item', {
        attrs: {
          "slot": "nested",
          "value": '#/' + i.v,
          "title": i.t
        },
        slot: "nested"
      })
    }), 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4b42f995!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/app-nav.vue
// module id = 1372
// module chunks = 129